import BaseComponent from "../core/base-component.js";

declare global {
	interface Window {
        OneTrust: any;
        OnetrustActiveGroups: string;
	}
	interface HTMLInputElement {
        isInitialized: boolean;
        isImageLinkInitialized: boolean;
	}
}

const DEFAULT_ELEMENT_SELECTOR: string = '[data-consent-required],[data-consent-required="1"]';

const pageConsentElementMap = new Map<HTMLElement, ConsentManager>();

class ConsentManager extends BaseComponent {
    private storageItemName: string = 'OnetrustActiveGroups';
    private consentInfo: HTMLElement|null;
    private category: string = '';
    private src: string = '';
    private customConsentMode: boolean = false;
    private consentInfoContainer: HTMLElement;
    private elParent: HTMLElement;

    public override init() {
        this.category = this.element.dataset.consentCategory ?? '';

        pageConsentElementMap.set(this.element, this);

        if(this.category == '') {
            for(const k in this.element.classList) {
                const matches = this.element.classList[k].match(/^optanon-category-(.*)$/);
                if(matches && matches[1]) {
                    this.category = matches[1];
                    break;
                }
            }
        }

        this.src = this.element.dataset.src ?? this.element.getAttribute('src') ?? '';
        this.customConsentMode = typeof(this.element.dataset.otIgnore) != 'undefined' ? true : false;
        if(this.customConsentMode) {
            this.storageItemName = 'CustomConsent_'+this.element.dataset.serviceVendor;
        }

        this.consentInfoContainer = this.element;
        this.elParent = this.element;
        if(this.element.parentElement && this.element.parentElement.classList.contains('embed-responsive')) {
            this.consentInfoContainer = this.element.parentElement.parentElement!;
            this.elParent = this.element.parentElement;
        }
    }

    public override process() {
        this.handleUpdate();
        let tries = 0;
        let oti = window.setInterval(() => {
            tries ++;
            if(typeof(window.OneTrust) != 'undefined' || tries > 20) {
                window.clearInterval(oti);
                this.handleUpdate();
            }
        }, 500);
    }

    public update() {
        this.handleUpdate();
    }

    public updateConsentElements(resetSrc: boolean = false) {
        pageConsentElementMap.forEach((consentManager: ConsentManager, el: HTMLElement) => {
            if(resetSrc) {
                el.removeAttribute('src');
            }
            consentManager.update();
        });
    }

    private handleUpdate() {
        const element = this.element as HTMLIFrameElement;
        let activeGroups: string = '';
        if(this.customConsentMode) {
            if(window.localStorage && window.localStorage.getItem(this.storageItemName) != null) {
                activeGroups += ',' + window.localStorage.getItem(this.storageItemName) + ',';
            } else {
                element.removeAttribute('src');
            }
        } else {
            if(window.OnetrustActiveGroups && window.OnetrustActiveGroups != '') {
                activeGroups += ',' + window.OnetrustActiveGroups + ',';
            }
        }

        if(this.consentInfo) {
            this.consentInfo.remove();
            this.consentInfo = null;
        }

        this.elParent.style.display = 'none';
        if(this.category != '' && activeGroups.search(',' + this.category + ',') < 0 && element.src == '') {
            let infoText = (element.dataset.consentInfo) ? element.dataset.consentInfo : '';
            let vendor = (element.dataset.serviceVendor) ? element.dataset.serviceVendor : '';
            let vendorInfo = (element.dataset.serviceVendorInfo) ? element.dataset.serviceVendorInfo : '';

            let consentInfoText = '<p>' + window.ThiemeCore.Lang.translate('consent.info') + '</p>';
            if(infoText != '') {
                consentInfoText = infoText;
            }
            if(vendor != '') {
                consentInfoText += '<p style="margin-left: 1rem;">' + window.ThiemeCore.Lang.translate('consent.vendor')+': ' + vendor + '</p>';
            }
            if(vendorInfo != '') {
                consentInfoText += '<p style="margin-left: 1rem;"><small>' + vendorInfo + '</small></p>';
            }

            consentInfoText += '<p><small>' + window.ThiemeCore.Lang.translate('consent.optoutInfo') + '</small></p>';

            this.consentInfo = document.createElement('div');
            this.consentInfo.setAttribute('class', 'alert alert-info');
            this.consentInfo.innerHTML = consentInfoText;

            let controlButton = document.createElement('button');
            controlButton.innerHTML = window.ThiemeCore.Lang.translate('consent.confirmAction');
            controlButton.setAttribute('class', 'btn btn-primary');
            controlButton.addEventListener('click', () => {
                activeGroups += ',' + this.category + ',';
                if(this.customConsentMode) {
                    window.localStorage.setItem(this.storageItemName, activeGroups);
                } else {
                    if(window.OneTrust) {
                        window.OneTrust.UpdateConsent('Category', this.category + ':1');
                    }
                }

                element.src = this.src;
                this.updateConsentElements();
            });

            this.consentInfo.append(controlButton);
            this.consentInfoContainer.after(this.consentInfo);
        } else {
            this.elParent.style.display = 'block';
            element.src = this.src;
            if(this.customConsentMode) {
                this.consentInfo = document.createElement('div');
                this.consentInfo.setAttribute('class', 'my-3 text-center');

                let controlButton = document.createElement('button');
                controlButton.innerHTML = window.ThiemeCore.Lang.translate('consent.optoutAction') + ' &raquo;';
                controlButton.setAttribute('class', 'btn btn-outline-secondary text-small');
                controlButton.addEventListener('click', () => {
                    activeGroups = '';
                    if(this.customConsentMode) {
                        window.localStorage.removeItem(this.storageItemName);
                    } else {
                        if(window.OneTrust) {
                            window.OneTrust.UpdateConsent('Category', this.category + ':0');
                        }
                    }
                    this.updateConsentElements(true);
                });

                this.consentInfo.append(controlButton);
                this.consentInfoContainer.after(this.consentInfo);
            }
        }


    }

}

// Observe
ConsentManager.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export default ConsentManager;
